import React, { useState } from 'react';
import PropTypes from 'prop-types';
import css from './Participants.css';
import StyledButton from 'common/StyledButton';
import { imageStyle } from '../utils/images';

// Max number of avatars displayed in a group session
const MAX_AVATARS = 3;

// Max number of participants displayed without a "More" button
const MAX_PARTICIPANTS = 5;

function Participants(props) {
  // Group sessions can be displayed without any participants, so we simply display static text for that.
  if (props.participants.length === 0) return <div className={css['no-participants']}>No students scheduled for this appointment.</div>;
  const [showAllParticipants, setShowAllParticipants] = useState(false);
  return (
    <li>
      <div className={css['participants-avatars']}>
        {props.participants.slice(0, MAX_AVATARS).map((participant, i) => (
          <div
            key={i}
            className={css['image']}
            style={{
              position: 'absolute',
              left: i * 25,
              ...imageStyle(participant.uuid, true)
            }}
            role="img"
          />
        ))}
        {props.participants.length > MAX_AVATARS && 
          <div
            className={`${css['image']} ${css['extra-participants']}`}
            role="img">
            +{props.participants.length - MAX_AVATARS}
          </div>
        }
      </div>
      <div className={css['participants-container']}>
        <div className={css['participants-names']}>
          {props
            .participants
            .slice(0, showAllParticipants ? props.participants.length : MAX_PARTICIPANTS)
            .map(({firstName, lastName, id}) => (
              <StyledButton 
                key={id} 
                asLink 
                onClick={() => props.openStudentFolder(id)}>
                {`${firstName} ${lastName}`}
              </StyledButton>
            ))
          }
        </div>
        {props.participants.length > MAX_PARTICIPANTS && 
          <StyledButton
            className={css['show-more-less']}
            asLink
            onClick={() => setShowAllParticipants(!showAllParticipants)}>
            {showAllParticipants ? "Less" : "More"}
          </StyledButton>
        }
      </div>
    </li>
  );
}

Participants.propTypes = {
  participants: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired,
  })).isRequired,
  openStudentFolder: PropTypes.func.isRequired,
};

export default Participants;
